import { render, staticRenderFns } from "./ExpiredVoucherTemplate.vue?vue&type=template&id=29ae9f04&scoped=true&"
import script from "./ExpiredVoucherTemplate.vue?vue&type=script&lang=js&"
export * from "./ExpiredVoucherTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ExpiredVoucherTemplate.vue?vue&type=style&index=0&id=29ae9f04&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ae9f04",
  null
  
)

export default component.exports